import type { Translations } from '@/i18n/types';

const es: Translations = {
  /* ── Common ───────────────────────────────────────────────── */
  'common.add': 'Añadir',
  'common.save': 'Guardar',
  'common.create': 'Crear',
  'common.edit': 'Editar',
  'common.delete': 'Eliminar',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.back': 'Atrás',
  'common.skip': 'Omitir',
  'common.search': 'Buscar',
  'common.retry': 'Reintentar',
  'common.reloadPage': 'Recargar página',
  'offline.title': 'Sin conexión',
  'offline.message': 'Actualmente no estás conectado a internet.',
  'common.loading': 'Cargando…',
  'common.optional': '(opcional)',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.none': '— Ninguno —',
  'common.notSet': '— No definido —',
  'common.deleting': 'Eliminando…',
  'common.applying': 'Aplicando…',
  'common.closeDialog': 'Cerrar diálogo',
  'common.prev': 'Ant.',
  'common.next': 'Sig.',

  /* ── Filter UI ────────────────────────────────────────────── */
  'filter.add': 'Añadir filtro',
  'filter.allActive': 'Todos los filtros activos',
  'filter.clearAll': 'Borrar todo',
  'filter.clear': 'Borrar',
  'filter.apply': 'Aplicar',
  'filter.cancel': 'Cancelar',
  'filter.condition': 'Condición',
  'filter.presets': 'Preajustes',
  'filter.customRange': 'Rango personalizado',
  'filter.from': 'Desde',
  'filter.to': 'Hasta',
  'filter.min': 'Mín.',
  'filter.max': 'Máx.',
  'filter.value': 'Valor',
  'filter.searchOptions': 'Buscar opciones...',
  'filter.noOptions': 'No se encontraron opciones',
  'filter.loadingOptions': 'Cargando opciones...',

  /* ── Auth ─────────────────────────────────────────────────── */
  'auth.signIn': 'Iniciar sesión',
  'auth.signInWithGoogle': 'Iniciar sesión con Google',
  'auth.signInWithApple': 'Iniciar sesión con Apple',
  'auth.or': 'o',
  'auth.signOut': 'Cerrar sesión',
  'auth.welcome': 'Bienvenido',
  'auth.subtitle': 'Editor de Karting',
  'auth.signingIn': 'Iniciando sesión...',

  /* ── Settings ───────────────────────────────────────────────── */
  'settings.title': 'Ajustes',
  'settings.account': 'Cuenta',
  'settings.profile': 'Perfil',
  'settings.displayName': 'Nombre visible',
  'settings.saveName': 'Guardar nombre',
  'settings.nameSaved': 'Nombre actualizado correctamente',
  'settings.linkedAccounts': 'Cuentas vinculadas',
  'settings.linkGoogle': 'Vincular cuenta de Google',
  'settings.linkApple': 'Vincular cuenta de Apple',
  'settings.unlink': 'Desvincular',
  'settings.linked': 'Vinculada',
  'settings.notLinked': 'No vinculada',
  'settings.cannotUnlinkOnlyProvider': 'Debe permanecer vinculado al menos un método de inicio de sesión.',
  'settings.language': 'Idioma',
  'settings.tracks': 'Circuitos',
  'settings.categories': 'Categorías',
  'settings.drivers': 'Pilotos',
  'settings.userId': 'ID de usuario',
  'settings.signOut': 'Cerrar sesión',
  'settings.connectedApps': 'Aplicaciones conectadas',
  'settings.connectedAppsDesc': 'Gestiona asistentes de IA, IDEs y herramientas autorizadas para acceder a tus datos de telemetría mediante MCP.',
  'settings.noConnectedApps': 'Aún no hay aplicaciones conectadas. Autoriza un cliente MCP (como Claude Desktop o Cursor) para verlo aquí.',
  'settings.authorizedOn': 'Autorizado',
  'settings.lastUsed': 'Último uso',
  'settings.neverUsed': 'Nunca',
  'settings.revoke': 'Revocar',
  'settings.revokeAppConfirm': '¿Seguro que quieres revocar el acceso de esta aplicación? Todas las sesiones activas dejarán de funcionar inmediatamente.',
  'settings.appRevokedSuccess': 'Acceso de la aplicación revocado correctamente',
  'settings.copyKey': 'Copiar fragmento',
  'settings.keyCopied': 'Copiado al portapapeles',
  'settings.mcpConfigSnippet': 'Configuración del cliente MCP',
  'settings.mcpConfigDesc': 'Añade esta configuración a los ajustes MCP de Claude Desktop (claude_desktop_config.json) o Cursor. La autenticación se completará automáticamente a través de tu navegador:',
  'settings.deleteAccount': 'Eliminar cuenta',
  'settings.deleteAccountDesc': 'Elimina permanentemente tu cuenta y todas las sesiones, datos de telemetría, análisis guardados, equipamiento, setups de kart y elementos compartidos asociados.',
  'settings.deleteAccountConfirmTitle': '¿Eliminar cuenta permanentemente?',
  'settings.deleteAccountConfirmDesc': 'Esta acción no se puede deshacer. Todas tus sesiones, datos de telemetría, análisis guardados, equipamiento, setups de kart, equipos y sesiones compartidas se eliminarán de forma inmediata y permanente.',
  'settings.deleteAccountConfirmPrompt': 'Para confirmar, escribe «{phrase}» en el cuadro de abajo:',
  'settings.deleteAccountConfirmPhrase': 'eliminar mi cuenta',
  'settings.deleteAccountConfirmButton': 'Eliminar mi cuenta',

  /* ── Common fields ────────────────────────────────────────── */
  'common.brand': 'Marca',
  'common.type': 'Tipo',
  'common.nr': 'N.º',
  'common.nrInfo': 'Número secuencial para identificar este elemento.',
  'common.year': 'Año',
  'common.stiffness': 'Dureza',
  'common.width': 'Anchura',
  'common.position': 'Posición',

  /* ── Tabs ──────────────────────────────────────────────────── */
  'tab.engines': 'Motores',
  'tab.tyres': 'Neumáticos',
  'tab.chassis': 'Chasis',
  'tab.carburetors': 'Carburadores',
  'tab.axles': 'Ejes',
  'tab.hubs': 'Bujes',
  'tab.spark_plugs': 'Bujías',
  'tab.tracks': 'Circuitos',
  'tab.categories': 'Categorías',
  'tab.drivers': 'Pilotos',
  'tab.races': 'Carreras',
  'tab.users': 'Usuarios',
  'tab.settings': 'Ajustes',

  /* ── Subtabs ──────────────────────────────────────────────── */

  /* ── Navigation ────────────────────────────────────────────── */
  'nav.administration': 'Administración',

  /* ── CRUD ──────────────────────────────────────────────────── */
  'crud.requiredField': '{field} es obligatorio',
  'crud.updated': '{entity} actualizado',
  'crud.created': '{entity} creado',
  'crud.deleted': '{entity} eliminado',
  'crud.confirmDelete': '¿Eliminar {entity} "{name}"?\nEsta acción no se puede deshacer.',
  'crud.emptyState': 'Aún no hay {title}. Añade tu primer {entity} arriba.',
  'crud.editEntity': 'Editar {entity}',
  'crud.newEntity': 'Nuevo {entity}',

  /* ── Entities ──────────────────────────────────────────────── */
  'entity.engine': 'Motor',
  'entity.tyre': 'Neumático',
  'entity.chassis': 'Chasis',
  'entity.carburetor': 'Carburador',
  'entity.axle': 'Eje',
  'entity.hub': 'Buje',
  'entity.spark_plug': 'Bujía',
  'entity.track': 'Circuito',
  'entity.category': 'Categoría',
  'entity.driver': 'Piloto',

  /* ── Sessions ──────────────────────────────────────────────── */

  /* ── Session Setup Dialog ──────────────────────────────────── */

  /* ── Search Help Dialog ────────────────────────────────────── */

  /* ── Import Dialog ─────────────────────────────────────────── */
  'import.title': 'Importar PDFs de carreras',
  'import.uploadDesc': 'Sube PDFs de resultados de carreras RMC. Se analizarán y se presentarán para su revisión antes de importarlos.',
  'import.dragDropPdf': 'Arrastra y suelta archivos PDF aquí',
  'import.orBrowse': 'o',
  'import.browseFiles': 'explorar archivos',
  'import.onlyPdfAccepted': 'Solo se aceptan archivos PDF.',
  'import.filesSelected': '{n} archivo(s) seleccionado(s)',
  'import.upload': 'Subir y analizar',
  'import.uploadingPct': 'Subiendo… {n}%',
  'import.parseFailed': 'Error al analizar la respuesta.',
  'import.uploadFailed': 'Error al subir. Inténtalo de nuevo.',
  'import.connectionLost': 'Conexión perdida.',
  'import.uploadAborted': 'Subida cancelada.',
  'import.reviewDesc': 'Revisa las sesiones analizadas. Deselecciona las que no quieras importar.',
  'import.selectAll': 'Seleccionar todo',
  'import.deselectAll': 'Deseleccionar todo',
  'import.existsInDb': 'Ya existe — se sobrescribirá',
  'import.entriesCount': '{n} inscritos',
  'import.submit': 'Importar',
  'import.submitting': 'Importando sesiones…',
  'import.importedCount': '{n} sesión(es) importada(s).',
  'import.successMessage': '¡Sesiones importadas correctamente!',
  'import.noNewSessions': 'No se importaron sesiones nuevas.',
  'import.imported': 'Importadas',
  'import.skipped': 'Omitidas',
  'import.errors': 'Errores',
  'import.importButton': 'Importar PDFs',

  /* ── Kart Setup Dialog ─────────────────────────────────────── */

  /* ── Setup Tab ──────────────────────────────────────────────── */

  /* ── Tyre Pressures ────────────────────────────────────────── */

  /* ── Front Geometry ────────────────────────────────────────── */

  /* ── Rear Config ───────────────────────────────────────────── */

  /* ── Engine & Gear ──────────────────────────────────────────── */

  /* ── Carburetor Tuning ──────────────────────────────────────── */

  /* ── Chassis Select ─────────────────────────────────────────── */

  /* ── Notes ──────────────────────────────────────────────────── */

  /* ── Propagation Wizard ─────────────────────────────────────── */

  /* ── Propagation field labels ───────────────────────────────── */

  /* ── Tracks ─────────────────────────────────────────────────── */
  'tracks.name': 'Nombre del circuito',
  'tracks.latitude': 'Latitud',
  'tracks.longitude': 'Longitud',
  'tracks.searchAddress': 'Buscar una dirección…',
  'tracks.coordinates': 'Coordenadas',
  'tracks.clickToAdjust': 'Haz clic en el mapa para ajustar el marcador',
  'tracks.tabLocation': 'Ubicación',
  'tracks.tabAliases': 'Alias',
  'tracks.sessionTracks': 'Circuitos de sesiones',
  'tracks.raceEventTracks': 'Circuitos de eventos de carrera',
  'tracks.noSessionTracks': 'No hay circuitos de sesiones disponibles',
  'tracks.noRaceEventTracks': 'No hay circuitos de eventos de carrera disponibles',
  'tracks.linkedAliases': '{sessions} circuitos de sesión · {races} circuitos de carrera',
  'tracks.satelliteImage': 'Imagen de satélite',
  'tracks.fetchImage': 'Obtener imagen de satélite',
  'tracks.refetchImage': 'Volver a obtener imagen de satélite',
  'tracks.fetchingImage': 'Obteniendo imagen…',
  'tracks.imageFetched': 'Imagen de satélite obtenida correctamente',
  'tracks.imageFetchFailed': 'Error al obtener la imagen de satélite',
  'tracks.noImage': 'Sin imagen de satélite',
  'tracks.imageZoom': 'Nivel de zoom',
  'tracks.autoZoom': 'Zoom automático',

  /* ── Categories ─────────────────────────────────────────────── */
  'categories.name': 'Nombre',
  'categories.aliases': 'Alias de categoría',
  'categories.noAliases': 'No hay nombres de categoría disponibles',
  'categories.linkedAliases': '{count} alias vinculados',

  /* ── Races ──────────────────────────────────────────────────── */
  'races.title': 'Sesiones de carrera',
  'races.loading': 'Cargando sesiones de carrera…',
  'races.empty': 'Aún no hay sesiones de carrera. Importa PDFs de carreras para empezar.',
  'races.loadFailed': '⚠ Error al cargar sesiones de carrera: {error}',
  'races.date': 'Fecha',
  'races.track': 'Circuito',
  'races.sessionType': 'Tipo',
  'races.category': 'Categoría',
  'races.entries': 'Inscritos',
  'races.laps': 'Vueltas',
  'races.championship': 'Campeonato',
  'races.deleteConfirmTitle': 'Eliminar sesión de carrera',
  'races.deleteConfirmMessage': '¿Seguro que quieres eliminar la sesión de <strong>{type}</strong> en <strong>{track}</strong> del <strong>{date}</strong>? Esto eliminará permanentemente todos los inscritos y datos de vueltas.',
  'races.deleteConfirmButton': 'Eliminar sesión',
  'races.deleted': 'Sesión de carrera eliminada',
  'races.detailTitle': 'Sesión de carrera',
  'races.detailSubtitle': '{type} · {track} · {date}',
  'races.position': 'Pos',
  'races.kart': 'Kart',
  'races.driver': 'Piloto',
  'races.firstName': 'Nombre',
  'races.lastName': 'Apellido',
  'races.nationality': 'Nac.',
  'races.grid': 'Parrilla',
  'races.bestLap': 'Mejor vuelta',
  'races.totalTime': 'Tiempo total',
  'races.penalty': 'Pen.',
  'races.gap': 'Dif.',
  'races.status': 'Estado',
  'races.deleteEntry': 'Eliminar inscrito',
  'races.entryDeleted': 'Inscrito eliminado',
  'races.saved': 'Sesión de carrera guardada',
  'races.searchPlaceholder': 'Buscar carreras… p. ej. Castelletto o type:race',
  'races.querySyntaxHelp': 'Ayuda de sintaxis de búsqueda',
  'races.sessionCount': '{count} sesiones',
  'races.sessionCountSingular': '1 sesión',

  /* ── Race Search Help Dialog ──────────────────────────────── */
  'raceSearchHelp.title': 'Sintaxis de búsqueda de carreras',
  'raceSearchHelp.subtitle': 'Filtra sesiones de carrera usando pares campo:valor. Varios términos se combinan con AND.',
  'raceSearchHelp.bareText': '(texto libre)',
  'raceSearchHelp.bareTextDesc': 'Coincide con el nombre del circuito o del campeonato que contenga el texto.',
  'raceSearchHelp.track': 'track',
  'raceSearchHelp.trackDesc': 'Coincide con el nombre del circuito que contenga el valor.',
  'raceSearchHelp.championship': 'championship',
  'raceSearchHelp.championshipDesc': 'Coincide con el nombre del campeonato que contenga el valor.',
  'raceSearchHelp.category': 'category',
  'raceSearchHelp.categoryDesc': 'Coincide con el nombre de la categoría que contenga el valor.',
  'raceSearchHelp.type': 'type',
  'raceSearchHelp.typeDesc': 'Coincide con el tipo o etiqueta de sesión (p. ej. race, qualifying, heat).',
  'raceSearchHelp.entries': 'entries',
  'raceSearchHelp.entriesDesc': 'Filtra por número de inscritos. Admite =, >, >=, <, <= y rangos.',
  'raceSearchHelp.laps': 'laps',
  'raceSearchHelp.lapsDesc': 'Filtra por número total de vueltas. Admite operadores de comparación y rangos.',
  'raceSearchHelp.season': 'season',
  'raceSearchHelp.seasonDesc': 'Filtra por año de temporada del campeonato. Admite operadores de comparación.',
  'raceSearchHelp.from': 'from',
  'raceSearchHelp.fromDesc': 'Carreras en o después de una fecha. Acepta YYYY-MM-DD o relativas: -7d, -2w, -3m, -1y.',
  'raceSearchHelp.to': 'to',
  'raceSearchHelp.toDesc': 'Carreras en o antes de una fecha. Mismos formatos que "from".',
  'raceSearchHelp.operatorsTitle': 'Operadores y lógica',
  'raceSearchHelp.numericComparisons': 'Comparaciones numéricas:',
  'raceSearchHelp.range': 'Rango:',
  'raceSearchHelp.rangeDesc': '— coincide con valores entre 5 y 20 inclusive.',
  'raceSearchHelp.booleanLogic': 'Lógica booleana:',
  'raceSearchHelp.booleanLogicDesc': 'Los términos se unen implícitamente con',
  'raceSearchHelp.quotes': 'Comillas:',
  'raceSearchHelp.quotesDesc': 'Envuelve los valores con espacios entre comillas dobles, p. ej.',
  'raceSearchHelp.examplesTitle': 'Ejemplos de consultas',
  'raceSearchHelp.example1Desc': 'Sesiones de carrera en Castelletto',
  'raceSearchHelp.example2Desc': 'Carreras del campeonato RMC del último año',
  'raceSearchHelp.example3Desc': 'Carreras con 20+ inscritos y 5+ vueltas',

  /* ── Pagination ─────────────────────────────────────────────── */
  'pagination.eventsFound': '{n} evento(s) encontrado(s)',

  /* ── Tyre IDs ──────────────────────────────────────────────── */

  /* ── Settings ──────────────────────────────────────────────── */
  'settings.users': 'Usuarios',

  /* ── Drivers ──────────────────────────────────────────────── */
  'drivers.canonicalDriver': 'Piloto canónico',
  'drivers.aliases': 'Alias',
  'drivers.aliasesHeader': 'Alias',
  'drivers.raceDrivers': 'Pilotos de carrera',
  'drivers.sessionDrivers': 'Pilotos de sesión',
  'drivers.noRaceDrivers': 'No hay pilotos de carrera disponibles',
  'drivers.noSessionDrivers': 'No hay pilotos de sesión disponibles',
  'drivers.selectDriver': 'Seleccionar un piloto…',
  'drivers.searchDrivers': 'Buscar pilotos…',
  'drivers.createTitle': 'Nuevo alias de piloto',
  'drivers.editTitle': 'Editar alias de piloto',
  'drivers.stepCanonical': 'Seleccionar piloto',
  'drivers.stepAliases': 'Seleccionar alias',

  /* ── Sharing ─────────────────────────────────────────────── */
  
  /* ── Users ──────────────────────────────────────────────── */
  'users.title': 'Usuarios',
  'users.empty': 'No se encontraron usuarios',
  'users.loading': 'Cargando usuarios...',
  'users.searchPlaceholder': 'Buscar usuarios...',
  'users.name': 'Nombre',
  'users.email': 'Correo electrónico',
  'users.user': 'Usuario',
  'users.admin': 'Administrador',
  'users.owner': 'Propietario',
  'users.promote': 'Promover',
  'users.demote': 'Degradar',
  'users.promoted': '{name} promovido a administrador',
  'users.demoted': '{name} eliminado como administrador',
  'users.cannotDemoteOwner': 'El propietario no puede ser degradado',
  'users.cannotDemoteSelf': 'No puedes degradarte a ti mismo',
  'users.confirmPromote': '¿Promover a {name} a administrador? Obtendrá acceso completo al editor.',
  'users.confirmDemote': '¿Retirar el acceso de administrador a {name}? Ya no podrá usar el editor.',
  'users.accessDenied': 'Acceso denegado',
  'users.accessDeniedMessage': 'No tienes privilegios de administrador. Contacta con un administrador para solicitar acceso.',
  'users.joinedAt': 'Registro',
  'users.lastLogin': 'Último acceso',
  'users.count': '{count} usuarios',
  'users.countSingular': '1 usuario',

  /* ── User Search Help Dialog ────────────────────────────── */
  'userSearchHelp.title': 'Búsqueda de usuarios',
  'userSearchHelp.subtitle': 'Filtra la lista de usuarios mediante consultas por campo o de texto libre.',
  'userSearchHelp.bareText': 'Texto libre',
  'userSearchHelp.bareTextDesc': 'Coincide tanto con el nombre como con la dirección de correo electrónico.',
  'userSearchHelp.name': 'name:',
  'userSearchHelp.nameDesc': 'Filtrar por nombre visible del usuario.',
  'userSearchHelp.email': 'email:',
  'userSearchHelp.emailDesc': 'Filtrar por dirección de correo electrónico.',
  'userSearchHelp.login': 'login:',
  'userSearchHelp.loginDesc': 'Filtrar por fecha de último acceso. Admite valores únicos (-7d) o rangos (-30d..today). Usa fechas relativas (-7d, -2w, -3m), absolutas (2026-01-15) o today.',
  'userSearchHelp.created': 'created:',
  'userSearchHelp.createdDesc': 'Filtrar por fecha de creación de la cuenta. Admite valores únicos (-30d) o rangos (-1y..today). Usa fechas relativas (-7d, -2w, -3m), absolutas (2026-01-15) o today.',
  'userSearchHelp.examplesTitle': 'Ejemplos',
  'userSearchHelp.example1Desc': 'Buscar usuarios llamados Yanick',
  'userSearchHelp.example2Desc': 'Buscar usuarios con direcciones de Gmail',
  'userSearchHelp.example3Desc': 'Buscar usuarios que iniciaron sesión en los últimos 7 días',
  'userSearchHelp.example4Desc': 'Buscar usuarios creados en un rango de fechas',

  /* ── Bugs tab ───────────────────────────────────────────────── */
  'tab.bugs': 'Errores',
  'bugs.title': 'Informes de errores',
  'bugs.empty': 'No se encontraron informes de errores.',
  'bugs.loading': 'Cargando informes de errores…',
  'bugs.searchPlaceholder': 'Buscar informes de errores…',
  'bugs.reporter': 'Informante',
  'bugs.description': 'Descripción',
  'bugs.pageUrl': 'URL de la página',
  'bugs.status': 'Estado',
  'bugs.statusOpen': 'Abierto',
  'bugs.statusResolved': 'Resuelto',
  'bugs.createdAt': 'Creado',
  'bugs.resolvedAt': 'Resuelto el',
  'bugs.resolve': 'Resolver',
  'bugs.reopen': 'Reabrir',
  'bugs.resolved': 'Informe de error resuelto.',
  'bugs.reopened': 'Informe de error reabierto.',
  'bugs.count': '{count} informes',
  'bugs.countSingular': '1 informe',
  'bugs.detailTitle': 'Informe de error',
  'bugs.userAgent': 'User Agent',
  'bugs.screenSize': 'Tamaño de pantalla',
  'bugs.appLanguage': 'Idioma',
  'bugs.copy': 'Copiar texto',
  'bugs.copied': 'Copiado al portapapeles',

  /* ── Bug search help ────────────────────────────────────────── */
  'bugSearchHelp.title': 'Sintaxis de búsqueda',
  'bugSearchHelp.subtitle': 'Usa estos prefijos para acotar tu búsqueda.',
  'bugSearchHelp.bareText': 'texto libre',
  'bugSearchHelp.bareTextDesc': 'Busca en la descripción y en el nombre del informante.',
  'bugSearchHelp.status': 'status:open',
  'bugSearchHelp.statusDesc': 'Filtrar por estado (open o resolved).',
  'bugSearchHelp.email': 'email:valor',
  'bugSearchHelp.emailDesc': 'Filtrar por correo del informante.',
  'bugSearchHelp.examplesTitle': 'Ejemplos',
  'bugSearchHelp.example1Desc': 'Buscar todos los informes de errores abiertos.',
  'bugSearchHelp.example2Desc': 'Buscar informes de errores de usuarios de Gmail.',

  /* ── Error auto-reporting & Error Boundary ─────────────────────────── */
  'error.autoReported': 'Se ha producido un error y se ha notificado automáticamente.',
  'errorBoundary.title': 'Algo salió mal',
  'errorBoundary.message': 'Se ha producido un error inesperado y se ha notificado al servidor.',
  'errorBoundary.reload': 'Recargar página',
  'errorBoundary.reset': 'Intentar de nuevo',
  'errorBoundary.showDetails': 'Mostrar detalles del error',
  'errorBoundary.hideDetails': 'Ocultar detalles del error',

  /* ── Profiles ───────────────────────────────────────────────── */
  'tab.profiles': 'Perfiles',
  'profiles.engineProfiles': 'Perfiles de motor',
  'profiles.tyreProfiles': 'Perfiles de neumático',
  'profiles.addEngineProfile': 'Añadir perfil de motor',
  'profiles.editEngineProfile': 'Editar perfil de motor',
  'profiles.addTyreProfile': 'Añadir perfil de neumático',
  'profiles.editTyreProfile': 'Editar perfil de neumático',
  'profiles.brand': 'Marca',
  'profiles.type': 'Tipo',
  'profiles.compound': 'Compuesto',
  'profiles.compoundDry': 'Seco',
  'profiles.compoundWet': 'Mojado',
  'profiles.deleteBlocked': 'No se puede eliminar — sigue referenciado por algún equipamiento.',
  'profiles.emptyEngineProfiles': 'Aún no hay perfiles de motor.',
  'profiles.emptyTyreProfiles': 'Aún no hay perfiles de neumático.',
  'entity.engineProfile': 'Perfil de motor',
  'entity.tyreProfile': 'Perfil de neumático',

  /* ── Track Shape Studio ────────────────────────────────────── */
  'trackStudio.title': 'Estudio de trazado y anotaciones del circuito',
  'trackStudio.subtitle': 'Diseña la geometría del circuito, edita splines y coloca anotaciones de curvas y sectores',
  'trackStudio.openStudio': 'Geometría y anotaciones del circuito',
  'trackStudio.modeSpline': 'Geometría y splines',
  'trackStudio.modeCorners': 'Curvas',
  'trackStudio.modeSectors': 'Sectores',
  'trackStudio.modeSegments': 'Segmentos',
  'trackStudio.bakeSegments': 'Generar 200 segmentos',
  'trackStudio.rebakeSegments': 'Regenerar 200 segmentos',
  'trackStudio.segmentsBakedSuccess': 'Se han generado {count} segmentos del circuito correctamente',
  'trackStudio.segmentsCount': '{count} segmentos',
  'trackStudio.segmentsStatusBaked': '200 segmentos generados',
  'trackStudio.segmentsStatusNotBaked': 'Aún no generados',
  'trackStudio.segmentsHint': 'Divide el eje central del circuito en 200 segmentos GPS estáticos equidistantes a partir de la línea de salida/meta para comparaciones de vueltas de alta precisión.',
  'trackStudio.segmentDetails': 'Detalles del segmento',
  'trackStudio.segmentIndex': 'Segmento #{index}',
  'trackStudio.avgSegmentLength': 'Longitud media de segmento',
  'trackStudio.searchSegments': 'Buscar segmentos...',
  'trackStudio.modeAnnotations': 'Anotaciones de curvas y sectores',
  'trackStudio.cornersCount': 'Curvas del circuito ({count})',
  'trackStudio.sectorsCount': 'Sectores de cronometraje ({count})',
  'trackStudio.clickCornersHint': 'Haz clic en cualquier punto de la pista para añadir una curva. Arrastra el vértice para moverla o ajustar los puntos de entrada y salida.',
  'trackStudio.clickSectorsHint': 'Haz clic en cualquier punto de la pista para colocar un marcador de corte de sector. Arrastra los marcadores para reposicionarlos a lo largo del circuito.',
  'trackStudio.trackLength': 'Longitud del circuito: {length} m',
  'trackStudio.trackWidth': 'Ancho de pista',
  'trackStudio.defaultTrackWidth': 'Ancho de pista predeterminado',
  'trackStudio.pointWidth': 'Ancho en el punto',
  'trackStudio.customWidth': 'Ancho personalizado para este punto',
  'trackStudio.useDefaultWidth': 'Usar predeterminado ({width} m)',
  'trackStudio.resetPointWidth': 'Restablecer al predeterminado',
  'trackStudio.segmentWidth': 'Herramienta de ancho de segmento',
  'trackStudio.segmentWidthDesc': 'Ajusta el ancho o crea transiciones suaves de ancho entre puntos',
  'trackStudio.fromPoint': 'Desde el punto',
  'trackStudio.toPoint': 'Hasta el punto',
  'trackStudio.startWidth': 'Ancho inicial',
  'trackStudio.endWidth': 'Ancho final',
  'trackStudio.transitionMode': 'Modo de transición',
  'trackStudio.modeConstant': 'Ancho constante',
  'trackStudio.modeGradient': 'Transición suave (Gradiente)',
  'trackStudio.applySegment': 'Aplicar ancho al segmento',
  'trackStudio.resetSegment': 'Restablecer ancho del segmento',
  'trackStudio.segmentApplied': 'Ancho actualizado para los puntos {from} a {to}',
  'trackStudio.controlPoints': 'Puntos de control del eje central ({count})',
  'trackStudio.addPointHint': 'Haz clic en la curva o en el lienzo para insertar puntos de control. Arrastra los puntos para remodelar.',
  'trackStudio.selectedPoint': 'Punto seleccionado #{index}',
  'trackStudio.deletePoint': 'Eliminar punto',
  'trackStudio.evenSpacePoints': 'Distribuir puntos uniformemente',
  'trackStudio.reverseDirection': 'Invertir dirección del circuito',
  'trackStudio.layerSatellite': 'Imagen de satélite',
  'trackStudio.layerCenterline': 'Spline del eje central',
  'trackStudio.layerBoundaries': 'Límites de la pista',
  'trackStudio.layerAnnotations': 'Anotaciones y marcadores',
  'trackStudio.undo': 'Deshacer (Cmd+Z)',
  'trackStudio.redo': 'Rehacer (Cmd+Shift+Z)',
  'trackStudio.reset': 'Restablecer cambios',
  'trackStudio.saveSuccess': '¡Trazado del circuito y anotaciones guardados correctamente!',
  'trackStudio.autoSaveSuccess': 'Trazado del circuito y anotaciones guardados automáticamente',
  'trackStudio.saveError': 'Error al guardar el trazado del circuito: {error}',
  'trackStudio.noCenterline': 'Haz clic en la imagen de satélite para crear el primer punto de control del eje central del circuito.',
  'trackStudio.annotations': 'Anotaciones del circuito ({count})',
  'trackStudio.addCorner': 'Añadir curva (T{next})',
  'trackStudio.addSector': 'Añadir marcador de sector',
  'trackStudio.addFinishLine': 'Establecer línea de salida / meta',
  'trackStudio.cornerName': 'Nombre de la curva',
  'trackStudio.cornerDirection': 'Dirección de la curva',
  'trackStudio.directionLeft': 'Curva a la izquierda',
  'trackStudio.directionRight': 'Curva a la derecha',
  'trackStudio.entry': 'Entrada (Giro / Frenada)',
  'trackStudio.apex': 'Vértice (Punto de cuerda)',
  'trackStudio.exit': 'Salida (Aceleración)',
  'trackStudio.deleteAnnotation': 'Eliminar anotación',
  'trackStudio.noAnnotations': 'Aún no se han creado anotaciones. Haz clic en el trazado del circuito para colocar curvas, sectores o la línea de salida/meta.',
  'trackStudio.finishLinePlaced': 'La línea de meta está activa al {pos}% de la vuelta.',
  'trackStudio.closeConfirm': 'Tienes cambios sin guardar. ¿Seguro que quieres cerrar el Estudio?',
  'trackStudio.menuAddCorner': 'Añadir curva',
  'trackStudio.menuAddSector': 'Añadir marcador de sector',
  'trackStudio.menuSetFinishLine': 'Establecer línea de salida / meta',
  'trackStudio.menuTrackPosition': 'Posición en pista',
  'trackStudio.clickTrackHint': 'Haz clic en cualquier punto de la pista para añadir una curva, un marcador de sector o establecer la línea de salida/meta.',
  'trackStudio.drivingDirection': 'Sentido de giro',
  'trackStudio.reverseDrivingDirection': 'Invertir sentido de giro',
  'trackStudio.drivingDirectionDesc': 'Invierte el sentido de giro del circuito. Todas las secuencias de curvas y sectores de cronometraje se adaptarán automáticamente.',
  'trackStudio.multiplePointsSelected': '{count} puntos seleccionados',
  'trackStudio.selectAll': 'Seleccionar todo (Cmd+A)',
  'trackStudio.deselectAll': 'Deseleccionar (Esc)',
  'trackStudio.deleteSelectedPoints': 'Eliminar {count} puntos',
  'trackStudio.customWidthSelection': 'Sobrescribir ancho personalizado (todos los seleccionados)',
  'tracks.reanalyzeLaps': 'Reanalizar vueltas del circuito',
  'tracks.reanalyzeAllLaps': 'Reanalizar todas las vueltas',
  'tracks.reanalyzeQueued': '{enqueued} vuelta(s) en cola para análisis ({skipped} ya actualizadas).',
  'tracks.reanalyzeForceQueued': '{enqueued} vuelta(s) en cola para recálculo completo.',
  'tracks.reanalyzeAllUpToDate': 'Las {skipped} vuelta(s) ya están actualizadas con los datos actuales del circuito.',
  'tracks.reanalyzeConfirmTitle': 'Reanalizar vueltas del circuito',
  'tracks.reanalyzeConfirmMessage': 'El hash de datos del circuito "{name}" no ha cambiado ({count} vuelta(s) ya están actualizadas). ¿Quieres forzar un recálculo completo para este circuito de todos modos?',
  'tracks.reanalyzeConfirmButton': 'Reanalizar vueltas',
  'tracks.reanalyzeAllConfirmTitle': 'Reanalizar todas las vueltas',
  'tracks.reanalyzeAllConfirmMessage': '¿Seguro que quieres iniciar un recálculo completo de todas las vueltas y sesiones en todos los circuitos?',

  /* ── Monitoring ────────────────────────────────────────────── */
  'tab.monitoring': 'Monitorización',
  'monitoring.title': 'Monitorización de colas',
  'monitoring.subtitle': 'Estadísticas en tiempo real y controles de procesamiento de las colas de análisis de vueltas y sesiones',
  'monitoring.refresh': 'Actualizar',
  'monitoring.autoRefreshActive': 'Actualizando automáticamente cada 3 s mientras está activo',
  'monitoring.lapQueueTitle': 'Cola de análisis de vueltas',
  'monitoring.sessionQueueTitle': 'Cola de análisis de sesiones',
  'monitoring.pending': 'Pendientes',
  'monitoring.processing': 'Procesando',
  'monitoring.completed': 'Completadas',
  'monitoring.failed': 'Fallidas',
  'monitoring.totalEligible': 'Total elegibles',
  'monitoring.actionsTitle': 'Controles globales de cola',
  'monitoring.syncUnanalyzed': 'Sincronizar no analizadas y desactualizadas',
  'monitoring.syncUnanalyzedDesc': 'Escanear todos los circuitos y poner en cola cualquier vuelta no analizada o con geometría de circuito desactualizada',
  'monitoring.syncUnanalyzedDone': '{enqueued} vuelta(s) en cola ({skipped} ya actualizadas).',
  'monitoring.retryFailed': 'Reintentar trabajos fallidos',
  'monitoring.retryFailedDesc': 'Restablecer todos los trabajos fallidos de análisis de vueltas y sesiones a estado pendiente',
  'monitoring.retryFailedDone': 'Se restablecieron {retried} trabajo(s) fallido(s) a pendiente.',
  'monitoring.reanalyzeAll': 'Forzar reanálisis de todas las vueltas',
  'monitoring.reanalyzeAllDesc': 'Forzar un recálculo completo de todas las vueltas y sesiones en todos los circuitos',
  'monitoring.userQueuesTitle': 'Progreso de cola por usuario (Round-Robin)',
  'monitoring.userQueuesSubtitle': 'El procesador reclama trabajos en orden round-robin entre usuarios para que los lotes grandes nunca bloqueen a otros usuarios',
  'monitoring.userQueuesEmpty': 'No hay trabajos activos ni en cola por usuario.',
  'monitoring.user': 'Usuario',
  'monitoring.systemQueue': 'Sistema / Global',
  'monitoring.lapsStatus': 'Trabajos de vueltas',
  'monitoring.sessionsStatus': 'Trabajos de sesiones',
  'monitoring.progress': 'Progreso',
  'monitoring.tracksTitle': 'Cobertura de análisis por circuito y controles de reanálisis',
  'monitoring.tracksSubtitle': 'Inspecciona la cobertura de análisis de vueltas por circuito canónico e inicia recálculos incrementales o forzados',
  'monitoring.tracksEmpty': 'Aún no hay circuitos canónicos configurados.',
  'monitoring.trackCoverage': 'Cobertura',
  'monitoring.upToDateLaps': 'Actualizadas',
  'monitoring.outdatedLaps': 'Desactualizadas',
  'monitoring.unanalyzedLaps': 'Sin analizar',
  'monitoring.shapeReady': '200 segmentos listos',
  'monitoring.noShape': 'Sin segmentos generados',
  'monitoring.reanalyzeTrack': 'Sincronizar / Reanalizar',
  'monitoring.forceReanalyzeTrack': 'Forzar todo',

  /* ── Terms & Conditions ────────────────────────────────────── */
  'terms.gateTitle': 'Términos y condiciones',
  'terms.gateSubtitle': 'Revisa y acepta la última versión de los Términos y condiciones para continuar.',
  'terms.updatedBannerTitle': 'Términos y condiciones actualizados:',
  'terms.updatedBannerDesc': 'Nuestros Términos y condiciones se han actualizado. Revisa y acepta la nueva versión para continuar.',
  'terms.checkboxLabel': 'He leído y acepto los Términos y condiciones',
  'terms.acceptButton': 'Aceptar y continuar',
  'terms.acceptingButton': 'Aceptando…',
  'terms.loadError': 'No se pudieron cargar los Términos y condiciones. Comprueba tu conexión e inténtalo de nuevo.',
  'terms.acceptError': 'No se pudo registrar tu aceptación. Inténtalo de nuevo.',

  /* ── Search & Filter Bar ───────────────────────────────────── */
  'search.placeholder': 'Buscar o añadir filtro...',
  'search.button': 'Buscar',
  'search.syntaxHelp': 'Ayuda de sintaxis de búsqueda',
  'search.title': 'Guía de sintaxis de búsqueda',
  'search.subtitle': 'Filtra y busca usando campos estructurados y operadores booleanos.',
  'search.closeDialog': 'Cerrar',
  'search.field.bareTextDesc': 'Buscar en los campos de texto predeterminados',
  'search.operatorsTitle': 'Operadores',
  'search.numericComparisons': 'Comparaciones numéricas / de fechas',
  'search.range': 'Rango (inclusivo)',
  'search.rangeDesc': 'Coincidir con valores entre mín y máx',
  'search.booleanLogic': 'Lógica booleana',
  'search.booleanLogicDesc': 'Combinar múltiples condiciones',
  'search.booleanLogicUse': 'Combina términos con',
  'search.booleanLogicOr': 'o',
  'search.booleanLogicGroup': 'y agrupa expresiones con paréntesis',
  'search.quotes': 'Cadenas entre comillas',
  'search.quotesDesc': 'Envuelve valores de varias palabras entre comillas (ej. track:"South Garda")',
  'search.examplesTitle': 'Ejemplos',

  'filter.operator.eq': 'es',
  'filter.operator.neq': 'no es',
  'filter.operator.gt': 'mayor que',
  'filter.operator.gte': 'al menos',
  'filter.operator.lt': 'menor que',
  'filter.operator.lte': 'como máximo',
  'filter.operator.range': 'entre',
  'filter.operator.contains': 'contiene',
  'filter.remove': 'Eliminar filtro',
  'filter.done': 'Listo',
  'filter.clearInput': 'Limpiar entrada',
  'filter.selectField': 'Filtrar por campo',
  'filter.pressEnter': 'Pulsa Intro para aplicar',
  'filter.selectValues': 'Seleccionar valores',
  'filter.noMatchingOptions': 'Sin opciones coincidentes',

  'filter.bugs.bareSearchExample': 'Buscar resumen, descripción o informador',
  'filter.bugs.searchSummary': 'Filtrar por resumen del error',
  'filter.bugs.searchDescription': 'Filtrar por descripción del error',
  'filter.bugs.searchReporter': 'Filtrar por nombre o correo del informador',
  'filter.bugs.filterStatus': 'Filtrar por estado del error',
  'filter.bugs.filterSeverity': 'Filtrar por nivel de gravedad',
  'filter.bugs.filterPlatform': 'Filtrar por plataforma (web, ios, android)',
  'filter.bugs.filterDate': 'Filtrar por fecha de reporte',
  'filter.bugs.exampleOpenHigh': 'Errores abiertos de gravedad alta',
  'filter.bugs.exampleMobileLogin': 'Problemas de inicio de sesión móvil',

  'filter.users.bareSearchExample': 'Buscar nombre, correo o ID de usuario',
  'filter.users.searchName': 'Filtrar por nombre visible',
  'filter.users.searchEmail': 'Filtrar por dirección de correo',
  'filter.users.searchId': 'Filtrar por ID de usuario',
  'filter.users.filterRole': 'Filtrar por rol asignado',
  'filter.users.exampleAdmin': 'Usuarios con el rol de administrador',
  'filter.users.exampleMultiRole': 'Administradores o editores por nombre',

  'filter.races.bareSearchExample': 'Buscar temporada, circuito, evento o piloto',
  'filter.races.searchSeason': 'Filtrar por nombre de temporada',
  'filter.races.filterYear': 'Filtrar por año del campeonato',
  'filter.races.searchCountry': 'Filtrar por código de país',
  'filter.races.searchCategory': 'Filtrar por categoría',
  'filter.races.searchTrack': 'Filtrar por nombre del circuito',
  'filter.races.searchEvent': 'Filtrar por título del evento',
  'filter.races.filterRound': 'Filtrar por número de ronda',
  'filter.races.searchSession': 'Filtrar por nombre de sesión',
  'filter.races.filterType': 'Filtrar por tipo de sesión',
  'filter.races.searchDriver': 'Filtrar por nombre del piloto',
  'filter.races.typePractice': 'Entrenamientos',
  'filter.races.typeQualifying': 'Clasificación',
  'filter.races.typeHeat': 'Manga clasificatoria',
  'filter.races.typePrefinal': 'Prefinal',
  'filter.races.typeFinal': 'Final',
  'filter.races.exampleRokTrack': 'Eventos ROK Cup en South Garda',
  'filter.races.exampleFinalDriver': 'Sesiones finales con un piloto',

  'races.season': 'Temporada',
  'races.year': 'Año',
  'races.country': 'País',
  'races.event': 'Evento',
  'races.roundLabel': 'Ronda',
  'races.session': 'Sesión',
  'races.type': 'Tipo',
  'races.label': 'Etiqueta',
  'races.time': 'Hora',

  'trackStudio.zoomIn': 'Acercar',
  'trackStudio.zoomOut': 'Alejar',
  'trackStudio.resetView': 'Restablecer vista',
  'trackStudio.geoLocation': 'Ubicación geográfica',
  'trackStudio.finishLineTitle': 'Línea de salida / meta',
  'trackStudio.finishLineHint': 'Arrastra el controlador de la bandera a lo largo de la pista en el lienzo, haz clic en la pista o usa el control deslizante inferior.',
  'trackStudio.staticGpsPosition': 'Posición GPS estática',
  'trackStudio.distance': 'Distancia',
  'trackStudio.previous': 'Anterior',
  'trackStudio.next': 'Siguiente',

  'users.terms': 'Términos',
  'users.termsAccepted': 'Aceptados',
  'users.termsOutdated': 'Desactualizados',
  'users.termsPending': 'Pendiente',
  'users.resetTerms': 'Restablecer términos y condiciones',
  'users.confirmResetTerms': '¿Restablecer la aceptación de los términos y condiciones para {name}? Deberá revisar y aceptar nuevamente los términos y condiciones antes de continuar.',
  'users.termsReset': 'Aceptación de términos y condiciones restablecida para {name}',
  // Filter Schema & UI Translations
  'filter.filterBy': 'Filtrar por {label}',
  'filter.removeFilter': 'Eliminar filtro {label}',
  'filter.prevMonth': 'Mes anterior',
  'filter.nextMonth': 'Mes siguiente',
  'filter.selectStartDate': 'Selecciona la fecha de inicio en el calendario',
  'filter.op.exact': 'Exacto',
  'filter.op.atLeast': 'Al menos',
  'filter.op.atMost': 'Como máximo',
  'filter.op.between': 'Entre',
  'filter.op.greater': 'Mayor',
  'filter.op.less': 'Menor',
  'filter.preset.today': 'Hoy',
  'filter.preset.last7d': 'Últimos 7 días',
  'filter.preset.last30d': 'Últimos 30 días',
  'filter.preset.last90d': 'Últimos 90 días',
  'filter.preset.last1y': 'Último año',
  'filter.preset.last7dShort': 'Últimos 7d',
  'filter.preset.last30dShort': 'Últimos 30d',
  'filter.preset.last90dShort': 'Últimos 90d',
  'filter.preset.last1yShort': 'Último 1a',
  'filter.sessionType.race': 'Carrera',
  'filter.sessionType.final': 'Final',
  'filter.sessionType.pre_final': 'Prefinal',
  'filter.sessionType.heat': 'Manga',
  'filter.sessionType.qualifying': 'Clasificación',
  'filter.unit.laps': 'vueltas',
  'filter.field.date': 'Fecha',
  'filter.field.track': 'Circuito',
  'filter.desc.track': 'Coincide con el nombre del circuito',
  'filter.field.championship': 'Campeonato',
  'filter.desc.championship': 'Nombre del campeonato',
  'filter.field.category': 'Categoría',
  'filter.desc.category': 'Categoría de carrera canónica',
  'filter.field.sessionType': 'Tipo de sesión',
  'filter.desc.sessionType': 'Clasificación de sesión (carrera, manga, clasificación, final)',
  'filter.field.laps': 'Vueltas',
  'filter.field.season': 'Temporada',
  'filter.desc.season': 'Coincide con el año de la temporada',
  'filter.field.driver': 'Piloto',
  'filter.placeholder.driver': 'p. ej. Yanick',
  'filter.placeholder.email': 'p. ej. gmail.com',
  'filter.desc.email': 'Coincide con la dirección de correo electrónico',
  'bugs.severity': 'Gravedad',
  'bugs.severityCritical': 'Crítica',
  'bugs.severityHigh': 'Alta',
  'bugs.severityMedium': 'Media',
  'bugs.severityLow': 'Baja',
  'bugs.statusInProgress': 'En curso',
  'bugs.statusClosed': 'Cerrado',
  'bugs.submitter': 'Correo del remitente',
  'filter.bugs.title': 'Sintaxis de búsqueda de informes de errores',
  'filter.bugs.subtitle': 'Filtra errores reportados por estado, gravedad, correo o palabras clave.',
  'filter.field.bugTitle': 'Resumen / Título',
  'filter.placeholder.bugTitle': 'p. ej. fallo, subida',
  'filter.desc.bugTitle': 'Coincide con el título o la descripción del problema',
  'filter.desc.bugStatus': 'Estado del problema (abierto, en curso, cerrado)',
  'filter.desc.bugSeverity': 'Nivel de gravedad del error',
  'filter.placeholder.bugEmail': 'p. ej. usuario@ejemplo.com',
  'filter.desc.bugEmail': 'Coincide con el correo del remitente',
  'filter.field.bugEnv': 'Entorno',
  'filter.desc.bugEnv': 'Filtrar por entorno de reporte (prod, dev, local)',
  'filter.bugs.example1': 'Todos los informes de errores abiertos',
  'filter.bugs.example2': 'Problemas abiertos en producción',
  'filter.bugs.example3': 'Informes de fallos abiertos',
  'filter.field.driverEntries': 'Pilotos inscritos',
  'filter.desc.driverEntries': 'Número total de pilotos participantes en la carrera',
  'filter.preset.entriesSmall': 'Pequeño (< 10)',
  'filter.preset.entriesMedium': 'Mediano (10..25)',
  'filter.preset.entriesLarge': 'Grande (> 25)',
  'filter.desc.raceLaps': 'Número de vueltas de carrera completadas',
  'filter.desc.raceDriver': 'Coincide con el nombre del piloto en los resultados de carrera',
  'filter.desc.raceDate': 'Filtrar carreras por periodo o rango de fechas del calendario',
  'filter.races.example1': 'Carreras de 2026 en Wohlen',
  'filter.races.example2': 'Parrillas grandes en Senior MAX',
  'filter.races.example3': 'Carreras con Yanick en el último año',
  'filter.users.title': 'Sintaxis de búsqueda de usuarios',
  'filter.users.subtitle': 'Filtra usuarios registrados por nombre, correo, rol o proveedor de autenticación.',
  'users.colName': 'Nombre',
  'users.colEmail': 'Correo electrónico',
  'users.colRole': 'Rol',
  'users.colProvider': 'Proveedor de acceso',
  'users.roleAdmin': 'Admin',
  'users.roleOwner': 'Propietario',
  'users.roleUser': 'Usuario',
  'filter.desc.userName': 'Coincide con el nombre visible del usuario',
  'filter.desc.userRole': 'Rol de usuario (admin, propietario, usuario)',
  'filter.desc.authProvider': 'Proveedor de autenticación',
  'filter.provider.password': 'Contraseña',
  'filter.desc.userDate': 'Fecha de creación o de última actividad',
  'filter.users.example1': 'Buscar usuarios que coincidan con Yanick',
  'filter.users.example2': 'Administradores de la plataforma',
  'filter.users.example3': 'Inicios de sesión con Google en los últimos 30 días',
};

export default es;

